import { Option } from '@/components/inputs/AutocompleteInput';
import { useState, useEffect, useCallback } from 'react';
import { ScannedCheckpointItem } from '../../models';

const STORAGE_KEY_ITEMS = 'batch_checkpoint_items';
const STORAGE_KEY_TRANSITION = 'batch_checkpoint_transition';

const getFromStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const saved = localStorage.getItem(key);
    return saved ? (JSON.parse(saved) as T) : defaultValue;
  } catch {
    return defaultValue;
  }
};

export const useScannerStorage = () => {
  const [transition, setTransition] = useState<Option | null>(() =>
    getFromStorage<Option | null>(STORAGE_KEY_TRANSITION, null)
  );

  const [scannedItems, setScannedItems] = useState<ScannedCheckpointItem[]>(() =>
    getFromStorage<ScannedCheckpointItem[]>(STORAGE_KEY_ITEMS, [])
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY_TRANSITION, JSON.stringify(transition));
    localStorage.setItem(STORAGE_KEY_ITEMS, JSON.stringify(scannedItems));
  }, [transition, scannedItems]);

  const clearStorage = useCallback(() => {
    setScannedItems([]);
    setTransition(null);
    localStorage.removeItem(STORAGE_KEY_ITEMS);
    localStorage.removeItem(STORAGE_KEY_TRANSITION);
  }, []);

  const clearItems = useCallback(() => {
    setScannedItems([]);
    localStorage.removeItem(STORAGE_KEY_ITEMS);
  }, []);

  const removeItem = useCallback((number: string) => {
    setScannedItems((prev) => prev.filter((item) => item.number !== number));
  }, []);

  return {
    transition,
    setTransition,
    scannedItems,
    setScannedItems,
    clearStorage,
    clearItems,
    removeItem,
  };
};
